import { name as creatorsListName } from './creators-list/config';
import * as CreatorsListFeature from './creators-list';
import * as AuthFeature from './auth';
import { name as dashboardName } from './dashboard/config';
import * as DashboardFeature from './dashboard';

export const features = {
    [creatorsListName]: CreatorsListFeature,
    [dashboardName]: DashboardFeature,
    [AuthFeature.name]: AuthFeature,
} as const;

export type Features = typeof features;
